import { render, staticRenderFns } from "./DsNavbar.vue?vue&type=template&id=344882b2&scoped=true"
import script from "./DsNavbar.vue?vue&type=script&lang=js"
export * from "./DsNavbar.vue?vue&type=script&lang=js"
import style0 from "./DsNavbar.vue?vue&type=style&index=0&id=344882b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344882b2",
  null
  
)

export default component.exports